import { GameConfig } from "../GameConfig/GameConfig.js";
import { EnemyConfig } from "../GameConfig/EnemyConfig.js";
import ShipFighterBurst from "../Bursts/enemy/ship-fighter-burst.js";

export default class Enemy {
    constructor() {
        this.image = new Image();
        this.x = GameConfig.CANVAS_WIDTH + EnemyConfig.SPAWN_BUFFER_DISTANCE_PX;

        this.markedForDeletion = false;

        this.frameX = 0;
        this.maxFrame = 0;

        // is being used for death animation as player continuously collieds with enemy while it is not moving from the death state while the death animation plays
        this.isColliding = true;
        this.projectiles = [];

        this.burst = new ShipFighterBurst();

        this.fps = GameConfig.FPS;
        this.frameTimer = GameConfig.FRAME_TIMER;
        this.frameInterval = GameConfig.FRAME_INTERVAL();
    }
    draw(context, deltaTime) {
        if (this.frameTimer > this.frameInterval) {
            if (this.frameX < this.maxFrame) this.frameX++;
            else this.frameX = 0;
            this.frameTimer = 0;
        } else if (typeof deltaTime == "number") {
            this.frameTimer = Number(this.frameTimer) + Number(deltaTime);
        }

        this.projectiles.forEach((projectile) => {
            projectile.draw(context, deltaTime);
        });
        this.burst.draw(context, deltaTime);

        context.drawImage(
            this.image,
            this.frameX * this.spriteWidth,
            0,
            this.spriteWidth,
            this.spriteHeight,
            this.x,
            this.y,
            this.spriteWidth,
            this.spriteHeight,
        );
    }

    update(deltaTime) {
        this.currentState.update(deltaTime);
        this.projectiles.forEach((projectile) => {
            projectile.update();
        });
        this.burst.update(this.x, this.y);
    }

    setState(statename) {
        this.currentState = this.states[statename];
        this.currentState.enter();
    }
}

export function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
